import { MdOutlineVerifiedUser } from "react-icons/md";
import { formatDate, formatPrice, openInNewTab } from "../../../utils/helpers";
import { Heart } from "lucide-react";
const getPostedBy = (listedBy) =>
  ({
    "buyer-owner": "Owner",
    "agent-builder": "Agent",
    "super-admin": "Admin",
  }[listedBy?.role] || null);

const HomePropertyCard = ({ property, redirectAllowed = true }) => {
  const price = formatPrice(property?.price);
  const address = property?.location;

  const handleClick = () => {
    if(redirectAllowed) openInNewTab(`/properties/residential/${property._id}`)
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-lg transition-all duration-200">
      {/* Image */}
      <div className="relative overflow-hidden bg-gray-100 rounded-t-xl">
        <img
          src={property?.thumbnail}
          alt={property.title}
          loading="lazy"
          onClick={handleClick}
          className="w-full cursor-pointer h-48 sm:h-52 object-cover transition-transform duration-500 hover:scale-105"
        />

        {true && (
          <div className="absolute top-3 left-0 bg-[#238C00] text-white px-2 py-1 rounded-r-md flex items-center gap-0.5 sm:gap-1 text-[0.6rem] sm:text-xs sm:font-medium">
            <MdOutlineVerifiedUser className="w-4 h-4" />
            Verified
          </div>
        )}

        {price && (
          <div className="absolute text-xs font-medium text-gray-900 bottom-3 right-3 bg-white px-2 py-1 rounded-md shadow">
            {price}
          </div>
        )}

        <button className="absolute top-3 right-3 bg-white p-2 rounded-full shadow">
          <Heart className="w-4 h-4 text-gray-600" />
        </button>
      </div>

      {/* Details */}
      <div className="p-3 lg:p-3">
        <h3
          onClick={handleClick}
          className="font-medium cursor-pointer text-[#031722] tracking-wide text-[0.9rem] line-clamp-1 mb-1.5"
        >
          {property.title}
        </h3>

        {/* Address */}
        <p className="text-[#6A6A6A] text-[0.8rem] line-clamp-1 mb-2">
          {address}
        </p>

        <div className="border-t border-slate-200/70 my-2"></div>

        <div className="text-[#797979] flex w-full justify-between items-center text-[0.7rem] pt-0.5">
          <div>Posted By {getPostedBy(property.listedBy)}</div>
          <div className="flex justify-end">
            {formatDate(property.createdAt)}
          </div>
        </div>
      </div>
    </div>
  );
};
export default HomePropertyCard;
